<template>
    <q-dialog :value="modalSize"
              transition-show="scale"
              transition-hide="scale"
              :maximized="$q.platform.is.mobile"
              @hide="hideProductSizeModal"
    >
        <q-card class="modal-select-size">
            <div class="modal-header">
                <span class="modal-title">Выберите размер</span>
                <div class="modal-close" @click.prevent="hideProductSizeModal">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <div class="product-size" :data-id="product.id">
                    <div v-for="size in product.sizes" class="product-size-item"
                         :class="{active: productSizeSelected(product.id, size.size ? size.size : size), 'product-size-item-long': size.length > 4, 'size-add-to-card': !skipAddToCartEvent}"
                         @click="clickProductSize(size.size ? size.size : size)">
                        {{ size.size ? size.size : size }}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import _ from "lodash";

export default {
    name: 'ProductSize',
    computed: {
        ...mapState('product', ['product', 'modalSize', 'callbackMutations', 'skipAddToCartEvent']),
        ...mapState('cart', ['cartErase']),
        ...mapGetters({
            productSizeSelected: 'product/sizeSelected'
        }),
        selectedProductDetails() {
            return this.$store.getters["product/getSelectedProductDetails"](this.product.id);
        },
    },
    methods: {
        ...mapMutations({
            hideProductSizeModal: 'product/hideProductSizeModal',
            toggleSize: 'product/toggleSize',
            showOneClickOrderModal: 'cart/showOneClickOrderModal',
            showAddToCartModal: 'cart/showAddToCartModal',
            hideDetailModal: 'product/hideDetailModal',
            setProduct: 'product/setProduct',
            toggleDetailModal: 'product/toggleDetailModal',
            setSelectedProductDetails: 'product/setSelectedProductDetails',
        }),
        ...mapActions({
            addProduct: 'cart/addProduct',
        }),
        clickProductSize (size) {
            let _this = this;

            this.toggleSize({ productId: this.product.id, size: size });
            this.addProduct({
                productId: this.product.id,
                sizeRequired: this.product.size_required,
                erase: this.cartErase
            }).then(() => {
                this.hideProductSizeModal();
                this.hideDetailModal();

                if (this.callbackMutations.length) {
                    this.callbackMutations.forEach(mutation => {
                        _.each(mutation, function(value, name) {
                            _this.$store.commit(name, value, { root: true });
                        });
                    });
                }
            }).catch(error => {
                this.hideProductSizeModal();
                this.setProduct(error.response.data.product);
                this.viewDetails();
            });
        },
        viewDetails () {
            if (!this.selectedProductDetails) {
                this.$store.dispatch('product/update', this.product.id);
            }
            this.toggleDetailModal(true);
        },
    },
}
</script>
